import { RouteObject } from 'react-router-dom';
import { MaintenanceGuard } from '../MaintenanceGuard';
import NPSLayout from '../components/layout/NPSLayout';
import { PreWorkCreateGroupContainer } from '../pages/prework/CreateGroupPage';
import { PreWorkAssignMentorContainer } from '../pages/prework/AssignMentorPage';
import { EditGroupContainerPrework } from '../pages/prework/EditGroupPage';
import { ViewGroupContainerPrework } from '../pages/prework/ViewGroupPage';
import { AddMoreCandidatesContainersPrework } from '../pages/prework/AddMoreCandidatesPage';
import {
	PREWORKGROUPS,
	PREWORK_ASSIGN_MENTOR,
	PREWORK_EDIT_GROUP,
	PREWORK_VIEW_GROUP,
	PREWORK_ADD_MORE_CANDIDATES,
} from '../shared/Routes';

export const PreworkRoutes: RouteObject[] = [
	{
		element: <MaintenanceGuard component={<NPSLayout />} />,
		children: [
			{
				path: PREWORKGROUPS,
				element: (
					<MaintenanceGuard component={<PreWorkCreateGroupContainer />} />
				),
			},
			{
				path: PREWORK_ASSIGN_MENTOR,
				element: (
					<MaintenanceGuard component={<PreWorkAssignMentorContainer />} />
				),
			},
			{
				path: PREWORK_EDIT_GROUP,
				element: <MaintenanceGuard component={<EditGroupContainerPrework />} />,
			},
			{
				path: PREWORK_VIEW_GROUP,
				element: <MaintenanceGuard component={<ViewGroupContainerPrework />} />,
			},
			{
				path: PREWORK_ADD_MORE_CANDIDATES,
				element: (
					<MaintenanceGuard
						component={<AddMoreCandidatesContainersPrework />}
					/>
				),
			},
		],
	},
];
